import React from 'react'

const HeroSection = () => {
  return (
    <div id='hero-section' className='hero-section d-flex justify-content-center align-items-center'>
        <div className="section-content text-center">
            <div className="section-heading text-light">
              Committed to Excellence
            </div>
            <div className="heading-ender"></div>
        </div>
    </div>
  )
}

export default HeroSection